const getReplaceItems = (outboundSelectedFare, inboundSelectedFare, outboundLegsBeingExchanged, inboundLegsBeingExchanged) => {
  let replaceItems = [];

  const rebookedPassengers = new Set(
    [...(outboundSelectedFare?.bookingItems || []), ...(inboundSelectedFare?.bookingItems || [])].map(({ passengerId }) => passengerId)
  );

  const legsExchanged = [
    ...(outboundLegsBeingExchanged?.flatMap((leg) => leg.products) || []),
    ...(inboundLegsBeingExchanged?.flatMap((leg) => leg.products) || [])
  ];

  replaceItems = legsExchanged
    ?.map(({ passengerId, uuid, cancelled }) => (rebookedPassengers.has(passengerId) && cancelled === false ? uuid : null))
    ?.filter(Boolean);

  return replaceItems;
};

export default getReplaceItems;
